import _ from 'lodash';
import React, { useMemo, useEffect } from 'react';
import Select from 'react-select';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

// Material UI
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import { FormHelperText, IFormOption } from '../../_core/_ui/forms.component';
import { ROLES } from '../../../../_configuration';
import { getAgeGroups, useRoleAllowedAgeGroups } from '../../../lib/services/age-group.service';
import { Label } from '../../_core/_ui/typography.component';

dayjs.extend(relativeTime);

interface InviteListProps {
  invites: Array<IInvite>;
  cancelInvite: Function;
  resendInvite: Function;
  showSent: string | null;
  ageGroup: IFormOption | null;
  setAgeGroup: (_: IFormOption | null) => void;
  canInviteToOrganization: boolean;
}

const InviteList: React.FC<InviteListProps> = ({
  invites,
  cancelInvite,
  resendInvite,
  showSent,
  ageGroup,
  setAgeGroup,
  canInviteToOrganization
}) => {
  const { ageGroups } = getAgeGroups()
  const roleAllowedAgeGroups = useRoleAllowedAgeGroups({ageGroups, requiredRoles: [ROLES.USER_MANAGEMENT]});

  const ageGroupOptions = useMemo(() => roleAllowedAgeGroups.map(ag => ({value: ag._id, label: ag.name})), [roleAllowedAgeGroups])

  return (
    <>
      {!canInviteToOrganization && (
        <Box mb={2}>
          <Label>Age Group</Label>
          <Select options={ageGroupOptions} value={ageGroup} onChange={setAgeGroup} />
        </Box>
      )}
      <Paper>
        <List>
          {_.map(invites, (invite: IInvite) => (
            <ListItem key={invite._id}>
              <ListItemText
                primary={invite.email}
                secondary={`Sent ${dayjs(invite.sentAt).fromNow()}`}
              />
              <ListItemSecondaryAction>
                <Box display="flex" alignItems="center">
                  {showSent === invite._id && (
                    <Box mr={2}>
                      <FormHelperText>Invite sent</FormHelperText>
                    </Box>
                  )}
                  <Box mr={1}>
                    <IconButton aria-label="delete" onClick={() => resendInvite(invite._id)}>
                      <SendIcon/>
                    </IconButton>
                  </Box>
                  <IconButton aria-label="delete" onClick={() => cancelInvite(invite._id)}>
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
          {!invites.length && (
            <ListItem>
              <ListItemText primary="None" />
            </ListItem>
          )}
        </List>
      </Paper>
    </>
  );
};

export default InviteList;
